<template>
  <div>
    <div class="flex-grow-1 overflow-auto" v-for="(dates, key) in availableDatesByDate" :key="key">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            class="text-left"
            block
            href="#"
            v-b-toggle="`acc${dates[0]}`"
            variant="default"
            >{{ dates[0] }}</b-button
          >
        </b-card-header>
        <b-collapse
          :id="`acc${dates[0]}`"
          :visible="key === 0"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-tabs pills content-class="mt-3">
              <b-tab
                :active="index != Object.keys(month).length - 1"
                v-for="(days, month, index) in dates[1]"
                :key="month"
                :title="formatMonth(month)"
              >
                <div v-for="(dataArray, day) in days" :key="day" class="mb-3">
                  <div
                    class="bg-dark text-white py-2 px-3 d-flex justify-content-between rounded-top"
                  >
                    <h6 class="m-0">{{ formatDay(dates[0], month, day, 'do MMMM') }}</h6>
                    <h6 class="m-0">{{ formatDay(dates[0], month, day, 'EEEE') }}</h6>
                  </div>
                  <div v-for="(event, i) in dataArray.data" :key="event.id">
                    <div
                      :class="{ 'rounded-bottom': i == dataArray.data.length - 1 }"
                      @click.prevent="activeDate = event.id"
                      style="cursor: pointer"
                      class="bg-white py-2 px-3 border-bottom border-left border-right border-dark mb-0"
                    >
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          {{ formatDate(event.starts_at.date, 'HH:mm') }} -
                          {{ formatDate(event.ends_at.date, 'HH:mm') }}
                          <span>
                            {{ event.product_info.data.name }} ({{ event.place.data.name }})
                          </span>
                        </div>
                        <div>
                          <strong>{{ event.booked_count }} av {{ event.participants }}</strong>
                          plasser
                          <change-participants-form :event="event" />
                        </div>
                      </div>
                      <div class="accordion" :class="{ open: activeDate === event.id }">
                        <date-modal :event="event" :selected-date="activeDate" />
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';
import DateModal from '@/components/booking/DateModal.vue';
import ChangeParticipantsForm from '@/components/booking/ChangeParticipantsForm.vue';

export default {
  components: {
    DateModal,
    ChangeParticipantsForm,
  },
  mounted() {
    if (this.$route.params.id) {
      let date = this.$route.params.id;
      this.activeDate = parseInt(date);
    }
  },
  computed: {
    ...mapGetters({
      availableDates: 'bookings/calendarDates',
      availableDatesByDate: 'bookings/availableDatesByDate',
    }),
  },
  data() {
    return {
      activeDate: null,
    };
  },
  methods: {
    ...mapActions({
      getAvailableDates: 'bookings/getAvailableDates',
    }),
    formatMonth(month) {
      return format(new Date(null, month, null), 'MMMM', { locale: nb });
    },
    formatDay(year, month, day, dateFormat) {
      return format(new Date(year, month - 1, day), dateFormat, { locale: nb });
    },
    formatDate(date, dateFormat) {
      return format(parseISO(date), dateFormat, { locale: nb });
    },
  },
};
</script>

<style>
.card-header .btn:focus {
  box-shadow: none;
}
.accordion {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.accordion.open {
  max-height: 1000px;
  transition: all 0.3s ease-in-out;
}
</style>
